import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]旗下基金
 */
export function queryFundManageredUsingPOST_1(
  req: InfoIaFundDto | void,
  config?: RequestConfig
): Promise<ApiResultListLcFundArchives> {
  return resource.postNoAuth('/fundInvestAdvisor/queryFundManagered', req, config);
}

/**
 * [No Auth]基金类型
 */
export function queryFundTypeUsingPOST(
  req: InfoIaDto | void,
  config?: RequestConfig
): Promise<ApiResultListProdCodeTypeDto> {
  return resource.postNoAuth('/fundInvestAdvisor/queryFundType', req, config);
}

/**
 * [No Auth]公司信息
 */
export function queryInvestAdvisorProfileUsingPOST(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultLcInvestAdvisorOutline> {
  return resource.postNoAuth('/fundInvestAdvisor/queryInvestAdvisorProfile', req, config);
}
